import React from 'react'
import { SelectField } from 'react-admin'
import { getLocaleChoices } from '../../utils/get-locale-choices/get-locale-choices'

export const LocaleField = ({ source }: { source: string }) => {
  const choices = getLocaleChoices()

  return <SelectField source={source} choices={choices} fullWidth />
}
